<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2018-->

<!--
  V/§11.7 V-015, 2026-06-26: removed inline height/overflow chain and
  the intermediate `<div style="flex-grow: 1; …">` wrapper. The chain
  wedged a no-padding div between `.content` (which carries the system
  36px horizontal padding via the appendix) and the quick-view's BS3
  `.row` (which uses -15px negative margins). Without `.content`'s
  padding to absorb the negative margin, the row extended 30px past
  the layout and caused horizontal scroll. Matching the canonical
  wrapper shape used by every other quick-view consumer (e.g. coaches,
  licensing-partners).
-->
<div id="nexleader-wrapper">
  <div class="content">
    <app-nexleader-quick-view
      *ngIf="invites"
      [model]="invites"
      [tableHeaders]="['Name', 'Email', 'Coach']"
      [tableColumns]="['_name', 'email', '_coach']"
      [label]="'Invites for ' + group?.name"
      [overrideDataNewElementText]="'Create Invite'"
      (overrideOnNewElement)="createInvite()"
      (onElementSelect)="selectedGroup = $event"
    >
      <ng-container *ngIf="selectedGroup?._id; else notSelected">
        <app-nexleader-invite-card
          [invite]="selectedGroup"
          (onChange)="load()"
        ></app-nexleader-invite-card>
      </ng-container>
      <ng-template #notSelected>
        <app-nexleader-quick-view-not-selected></app-nexleader-quick-view-not-selected>
      </ng-template>
    </app-nexleader-quick-view>
  </div>
</div>
